import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from '@core/service/auth.service';

export const accueilGuard: CanActivateFn = (route, state) => {
    const auth = inject(AuthService);
  const router = inject(Router);

  console.log('checking accueil: ',auth.hasAccess('ACCUEIL'))
  if (auth.hasAccess('ACCUEIL')) {
    return true;
  }
  else{
    router.navigate(["/authentication/signin"]);
    return false;

  }
};
